import(/* webpackMode: "eager" */ "/app/nettleworth-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nettleworth-frontend/src/components/CustomImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nettleworth-frontend/src/components/LocaleLink.js");
